module.exports = __webpack_public_path__ + "media/MarketplaceLogo.74075d9cfc4f0399679cac7688809873.svg";